// URL Parameters and Tracking Codes
export const BRAND_BASE_URL = "https://gundrymd.com";
export const CDN_BASE_URL = "https://cdn.gundrymd.com";
export const CART_BASE_URL = "https://cart.gundrymd.com";
export const BRIGHTCOVE_BASE_URL = "https://players.brightcove.net/6058004206001";
export const ONE_SHOPPING_CART_URL = "https://www.1shoppingcart.com";

// External Service URLs
export const EXTERNAL_URLS = {
  THEHEALTHYFAT: "https://www2.thehealthyfat.com",
  PAYPAL_BUTTON: "https://www2.thehealthyfat.com/assets/img/paypalButton.jpg"
};

// Podcast URLs
export const PODCAST_URLS = {
  ITUNES: "https://itunes.apple.com/us/podcast/the-dr-gundry-podcast/id1434371530",
  YOUTUBE: "https://www.youtube.com/playlist?list=PLdIdMvoKskiSDn3ZxzRkqtxtY_oGKqbRl",
  STITCHER: "https://www.stitcher.com/podcast/the-dr-gundry-podcast",
  OVERCAST: "https://overcast.fm/itunes1434371530/the-dr-gundry-podcast",
  CASTBOX: "https://castbox.fm/search?q=Dr%20Gundry%20Podcast&country=us&skip=0&limit=50&order=relevance&research=1"
};

// CDN Image URLs
export const CDN_IMAGES = {
  GUNDRY_LOGO: `${CDN_BASE_URL}/images/gundry-logo.jpg`,
  GUNDRY_LOGO_SHORT: `${CDN_BASE_URL}/images/GundryMD-Logo_short.png`,
  PALM_WAIT: `${CDN_BASE_URL}/images/palm_wait.svg`,
  UP_YES: `${CDN_BASE_URL}/images/upYes.jpg`,
  UP_NO: `${CDN_BASE_URL}/images/upNo.jpg`,
  UP_YES_MOBILE: `${CDN_BASE_URL}/images/upYes_mobile.jpg`,
  UP_NO_MOBILE: `${CDN_BASE_URL}/images/upNo_mobile.jpg`,
  GRAY_CHECK: `${CDN_BASE_URL}/images/gray_check2.png`,
  BLUE_CHECK: `${CDN_BASE_URL}/images/blue_check.png`,
  HEALTH_IMAGE: `${CDN_BASE_URL}/images/5c1e24a802aa7adbf71d89a06ddb417581fa46ea.jpg`,
  FIELD_DESKTOP: `${CDN_BASE_URL}/images/Field_Desktop.png`,
  GUNDRY_BOTTOM_CORNER: `${CDN_BASE_URL}/images/gundry-bottom-corner.png`,
  SPINNING_WHEEL_CIRCLES: `${CDN_BASE_URL}/images/spinning-wheel-small_circlesfull.png`,
  SPINNING_WHEEL_TRIANGLE: `${CDN_BASE_URL}/images/spinning-wheel-triangle.png`,
  MONEYBACK_GUNDRY: `${CDN_BASE_URL}/images/moneyback-gundry.png`,
  PHONE: `${CDN_BASE_URL}/images/phone.png`,
  GUNDRY_BODY: `${CDN_BASE_URL}/images/gundry-body.png`,
  RED_CHECK: `${CDN_BASE_URL}/images/red-check.png`,
  LOGO_CIRCLE: `${CDN_BASE_URL}/images/logo-circle.png`,
  BIOC_COMPLETE3_SUPP: `${CDN_BASE_URL}/images/bio-complete-3/BioComplete3-supp.png`,
  STAR_GREEN: `${CDN_BASE_URL}/1starGreen.png`,
  MYACCOUNT_CHECKMARK: `${CDN_BASE_URL}/images/Myaccount-checkmark-sign-up.png`,
  GUNDRY_SCRUBS_GREEN: `${CDN_BASE_URL}/images/gundry_scrubs_green.png`,
  GUNDRY_LOGO_3X: `${CDN_BASE_URL}/images/GundryMD-Logo@3x.png`,
  GUNDRY_SCRUBS: `${CDN_BASE_URL}/images/Gundry_Scrubs.png`,
  PHONE2: `${CDN_BASE_URL}/images/phone2.png`,
  CHECKOUT_90DAY: `${CDN_BASE_URL}/images/checkout_90day.png`,
  TROPHY: `${CDN_BASE_URL}/images/trophy.svg`,
  CHECKOUT_TRUCK: `${CDN_BASE_URL}/images/checkout_truck.svg`,
  SUBSCRIPTION_TERMS: `${CDN_BASE_URL}/Terms_Conditions/gundry-subscription-terms.html`
};

export const PARAM = "n";
export const OBTCR = "obtcr";
export const TBATCR = "tbatcr";
export const FBTCR = "fbtcr";
export const DBTCR = "dbtcr";
export const REVTCR = "revtcr";
export const ADV = "Advertorial";
export const ADVERT = "Advertisement";
export const OPT = 'opt';
export const OBNATCR = 'obnatcr';
export const MSNTCR = 'msntcr';
export const OB = 'ob';
export const AOL = 'aol';
export const AOLTCR = 'aoltcr';
export const GDN = 'gdn';
export const GDNTCR = 'gdntcr';
export const AYAHTCR = 'ayahtcr';
export const AYAHC = 'ayahc';
export const AYAHLG = 'ayahlg';
export const ATBATCR = 'atbatcr';
export const VMXGUN = 'vmxgun';
export const RMGEM = 'rm-gem';
